// Spark / includes/newsletter - подписка на рассылку.
// Модуль подключён в core.js и инициализируется сам, без вызова со
// стороны: футер есть на каждой странице.
//
// Форм на странице может быть несколько (футер + cta-баннер хаба
// категорий) - обходим все .newsletter-form. Состояние
// (сообщение, busy) у каждой своё, живёт в замыкании initForm.
//
// Разметка не размечена data-action: делегатор core.js завязан на клики
// по кнопкам панелей шапки, а тут нужен submit формы - и клик по кнопке,
// и Enter в поле разом.
//
// Бэк: Apps\Ajax\Controllers\NewsletterController::subscribeAction.
// Контроллер отвечает 400 (пустой/битый адрес) и 429 (rate-limit)
// - оба уезжают в catch и pickMessage покажет серверный текст.

import { axios } from '../plugins/http';

const ENDPOINT = '/newsletter/subscribe';

const TEXT = {
    empty   : 'Please enter your email.',
    invalid : 'Please enter a valid email address.',
    ok      : 'Thanks! Check your inbox to confirm.',
    fail    : 'Something went wrong. Please try again.',
};

function initForm( form ) {

    const input = form.querySelector('.newsletter-input');
    const btn   = form.querySelector('.newsletter-btn');

    if( ! input || ! btn )
        return;

    // Узел сообщения создаётся лениво, чтобы не держать пустой div в
    // футере, и уходит последним элементом внутрь формы - под поле с
    // кнопкой. aria-live - чтобы скринридер озвучил результат: фокус в
    // этот момент остаётся на кнопке.
    let msgNode = null;

    function message( text ) {

        if( ! msgNode ) {
            msgNode = document.createElement('p');
            msgNode.className = 'newsletter-msg';
            msgNode.setAttribute('aria-live', 'polite');
            form.append( msgNode );
        }

        msgNode.textContent = text;
    }

    function clearMessage() {

        if( msgNode )
            msgNode.textContent = '';
    }

    // Блокировка на время запроса: повторный клик и Enter не должны
    // отправить второй раз (таймаут axios - 10с, успеть можно).
    let busy = false;

    const label = btn.textContent;

    function setBusy( state ) {

        busy         = state;
        btn.disabled = state;
        input.disabled = state;
        btn.textContent = state ? 'Sending...' : label;
    }

    // Достаём текст ошибки из ответа, если бэк его прислал; иначе - общий.
    function pickMessage( payload, fallback ) {

        const text = payload && payload.data && payload.data.message;

        return typeof text === 'string' && text ? text : fallback;
    }

    function submit() {

        if( busy )
            return;

        // required + type="email" уже дают браузерную проверку - берём её,
        // чтобы не заводить свою регулярку и не расходиться с браузером.
        // Форма с novalidate, поэтому пузырь браузер не покажет: текст
        // выбираем сами и кладём в общий узел сообщения.
        if( ! input.checkValidity() ) {
            message( input.validity.valueMissing ? TEXT.empty : TEXT.invalid );
            input.focus();
            return;
        }

        const email = input.value.trim();

        clearMessage();
        setBusy( true );

        axios.post( ENDPOINT, { email } )
            .then( ({ data }) => {
                message( pickMessage( data, TEXT.ok ) );
                input.value = '';
            })
            .catch( ( err ) => {
                message( pickMessage( err.response && err.response.data, TEXT.fail ) );
            })
            .finally( () => setBusy( false ) );
    }

    // Один слушатель на оба способа отправки: клик по кнопке и Enter в поле.
    form.addEventListener( 'submit', ( e ) => {
        e.preventDefault();
        submit();
    });

    // Начал править - прошлая ошибка больше не про то, что в поле сейчас.
    input.addEventListener( 'input', clearMessage );
}

document.querySelectorAll('.newsletter-form').forEach( initForm );
